export default __webpack_public_path__ + "static/media/right.3239e080.png";